import { createResource } from 'redux-rest-resource';
import { HEADERS as headers, GROUPS_URL } from '../../Constants';
import { transformFetchResponse as transformResponse } from '../../Helpers';

export const { types, actions, reducers } = createResource({
  name: 'group',
  url: `${GROUPS_URL}/:id`,
  headers,
  actions: {
    createMany: {
      gerundName: 'creatingMany',
      isArray: true,
      method: 'POST',
      url: `${GROUPS_URL}/many`,
    },
    fetch: {
      transformResponse,
    },
  },
});
